import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'groupweekreport',
  templateUrl: './groupweekreport.component.html',
  styleUrls: ['./groupweekreport.component.css']
})
export class GroupWeekReportComponent implements OnInit {
  periodType:string = "week";
  spinnerMessage: string = 'Please wait, report data is fetched';

  constructor() { }

  ngOnInit() {
  }

}
